import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { postBank } from '../../../../actions';
import { BANK_PATH } from '../../../../config/paths';
import { breadcrumbsPropTypes } from '../../../common/resource/proptypes/CommonPropTypes';
import Content from '../../../layout/Content';
import BankForm from './BankForm';

const NewBank = ({ breadcrumbs, dispatchPostBank }) => {
  const onSubmit = (formValues) =>
    dispatchPostBank({
      ...formValues,
      countryId: formValues.countryId.id,
    });

  const content = <BankForm onSubmit={onSubmit} />;
  return (
    <Content
      breadcrumbs={breadcrumbs}
      title="Nuevo Banco"
      subtitle="Crear nuevo banco."
      content={content}
    />
  );
};

const mapDispatchToProps = {
  dispatchPostBank: postBank,
};

const mapStateToProps = ({ AccountingUnit }) => ({
  breadcrumbs: [
    ...AccountingUnit.UnitHome.get('breadcrumbs'),
    {
      text: 'Bancos',
      href: BANK_PATH,
    },
    {
      text: 'Nuevo banco',
      href: '',
    },
  ],
});

NewBank.propTypes = {
  breadcrumbs: breadcrumbsPropTypes.isRequired,
  dispatchPostBank: PropTypes.func.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(NewBank);
